var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.item)?_c('div',{staticClass:"container-fluid mx-auto"},[_c('div',{staticClass:"flex flex-wrap -mx-4"},_vm._l((_vm.item.content),function(child){return _c('sb-render',{key:child._uid,attrs:{"item":child}})}),1)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }